export default "__VITE_ASSET__CMILlHvj__"